export default {"src":"/_next/static/media/section4.40898fdf.svg","height":329,"width":328,"blurWidth":0,"blurHeight":0};